import React from 'react';
import { Typography, Box, SvgIcon, Link } from '@mui/material';
import { IbssComponent } from '../../../../../Components/Core/BaseComponent/IbssComponent';
import { appContext } from '../../../../../AppContext';
import IbssDrawer from '../../../../../Components/Drawer/IbssDrawer';
import CloseIcon from '../../../../../Components/Icons/CloseIcon';
import IbssTextField from '../../../../../Components/Inputs/TextField/IbssTextField';
import IbssSwitchLabel from '../../../../../Components/Inputs/Switch/IbssSwitchLabel';
import IbssPageHeader from '../../../../../Components/Headings/PageHeading/IbssPageHeader';

class EditStoreDrawer extends IbssComponent<IProps, IState>
{
    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);
    }

    public render(): JSX.Element
    {
        return (
            <IbssDrawer open={this.props.open} onClose={() => this.props.onClose()} anchor='right' className='flex-search-filter-criteria' sx={{ backgroundColor: "var(--ui-background-alternate)" }}>
                <Box className="tablePanel" p={4}>
                    <Box display={"flex"} sx={{ cursor: "pointer" }} justifyContent={"flex-end"} >
                        <SvgIcon onClick={() => this.props.onClose()}>
                            <CloseIcon />
                        </SvgIcon>
                    </Box>
                    <IbssPageHeader
                        title={this.labels.funcEquipmentStore_S}
                        description={this.labels.funcEquipmentStore_D}
                    />
                    <hr />
                    <Box my={1} gap={3} flexDirection={'column'} display={'flex'}>
                        <IbssTextField
                            fullWidth
                            label={this.labels.funcStoreSpaceID_S}
                            value={this.props.selectedStore.id}
                        />
                        <IbssTextField
                            fullWidth
                            label={this.labels.funcStoreName_S}
                            value={this.props.selectedStore.storeName}
                        />
                        <IbssTextField
                            fullWidth
                            label={this.labels.funcCustomInformation_S}
                            value={this.props.selectedStore.storeCustomInfo}
                        />
                        <IbssTextField
                            fullWidth
                            label={this.labels.funcFloorLocation_S}
                            value={this.props.selectedStore.floorName}
                        />
                        <IbssSwitchLabel
                            checked={this.props.selectedStore.status === 'Active' ? true : false}
                            label={this.labels.HubLabelEnable}
                        />
                    </Box>
                </Box>
            </IbssDrawer>
        );
    }
}

export default EditStoreDrawer;

export interface IProps
{
    open: boolean;
    selectedStore: IEquipmentStore;
    buildingId: number;
    onClose: () => void;
}

export interface IState
{

}

export interface IEquipmentStore
{
    id: string;
    storeName: string;
    floorName: string;
    floorId: number;
    status: 'Active' | 'Inactive';
    storeCustomInfo: string;
}